module.exports = __webpack_public_path__ + "static/img-web-dev-70753baa1ba1cabd0f6d6e49efc8dd0d.jpg";